/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomRiskObjectRequestDtoDto } from '../models/pom-risk-object-request-dto-dto';
import { PomRiskObjectResponseDto } from '../models/pom-risk-object-response-dto';
import { PomRiskObjectsResponseDto } from '../models/pom-risk-objects-response-dto';

@Injectable({
  providedIn: 'root',
})
export class RiskObjectService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fetch4
   */
  static readonly Fetch4Path = '/offer/riskobject/{id}';

  /**
   * Get risk object
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetch4()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetch4$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomRiskObjectResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, RiskObjectService.Fetch4Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomRiskObjectResponseDto>;
      })
    );
  }

  /**
   * Get risk object
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetch4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetch4(params: {
    id: string;
  },
  context?: HttpContext

): Observable<PomRiskObjectResponseDto> {

    return this.fetch4$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomRiskObjectResponseDto>) => r.body as PomRiskObjectResponseDto)
    );
  }

  /**
   * Path part for operation update3
   */
  static readonly Update3Path = '/offer/riskobject/{id}';

  /**
   * Update risk object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update3$Response(params: {
    id: string;
    body: PomRiskObjectRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RiskObjectService.Update3Path, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Update risk object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update3(params: {
    id: string;
    body: PomRiskObjectRequestDtoDto
  },
  context?: HttpContext

): Observable<number> {

    return this.update3$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation create4
   */
  static readonly Create4Path = '/offer/riskobject';

  /**
   * Create new risk object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create4()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create4$Response(params: {
    body: PomRiskObjectRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RiskObjectService.Create4Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Create new risk object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create4$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create4(params: {
    body: PomRiskObjectRequestDtoDto
  },
  context?: HttpContext

): Observable<number> {

    return this.create4$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation list1
   */
  static readonly List1Path = '/product/{productId}/riskobject';

  /**
   * Get list of risk objects
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list1()` instead.
   *
   * This method doesn't expect any request body.
   */
  list1$Response(params: {

    /**
     * Id of the product
     */
    productId: number;

    /**
     * Number of page
     */
    page: number;

    /**
     * Size of page
     */
    size: number;

    /**
     * Filter that can be applied to the list of results
     */
    filter?: Array<string>;

    /**
     * Sorting that can be applied to the list of results
     */
    sort?: Array<string>;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomRiskObjectsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, RiskObjectService.List1Path, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('filter', params.filter, {});
      rb.query('sort', params.sort, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomRiskObjectsResponseDto>;
      })
    );
  }

  /**
   * Get list of risk objects
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list1(params: {

    /**
     * Id of the product
     */
    productId: number;

    /**
     * Number of page
     */
    page: number;

    /**
     * Size of page
     */
    size: number;

    /**
     * Filter that can be applied to the list of results
     */
    filter?: Array<string>;

    /**
     * Sorting that can be applied to the list of results
     */
    sort?: Array<string>;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<PomRiskObjectsResponseDto> {

    return this.list1$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomRiskObjectsResponseDto>) => r.body as PomRiskObjectsResponseDto)
    );
  }

}
